import { instance as api } from './index';

/**
 * Service für Restaurant-Einstellungen API-Anfragen
 */
export const restaurantSettingsService = {
  /**
   * Lädt die Einstellungen des Restaurants
   * @returns {Promise} Antwort mit den Restaurant-Einstellungen
   */
  async getSettings() {
    try {
        const response = await api.get('/RestaurantSettings');
      return response.data;
    } catch (error) {
      console.error('Fehler beim Laden der Restaurant-Einstellungen:', error);
      throw error;
    }
  },

  /**
   * Aktualisiert die Restaurant-Einstellungen
   * @param {Object} settings - Die zu aktualisierenden Einstellungen
   * @returns {Promise} Antwort mit den aktualisierten Einstellungen
   */
  async updateSettings(settingsData) {
    try {
      // Verwende axiosInstance statt axios direkt
      const response = await api.put('/RestaurantSettings', settingsData);
      return response.data;
    } catch (error) {
      console.error('Fehler beim Aktualisieren der Restaurant-Einstellungen:', error);
      throw error;
    }
  },

  /**
   * Lädt ein Logo für das Restaurant hoch
   * @param {File} file - Die Logo-Datei
   * @returns {Promise} Antwort mit der Logo-URL
   */
  async uploadLogo(formData) {
    try {
      console.log('Sende Logo-Upload-Request:', {
        formData: formData,
        hasLogoFile: formData.has('LogoFile'),
        file: formData.get('LogoFile')
      });

      const response = await api.post('/RestaurantSettings/logo', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
      return response;
    } catch (error) {
      console.error('Fehler beim Hochladen des Logos:', error);
      if (error.response) {
        console.error('Server-Antwort:', error.response.data);
      }
      throw error;
    }
  },

  /**
   * Ändert das Passwort des Restaurant-Administrators
   * @param {Object} passwordData - Passwort-Daten mit currentPassword und newPassword
   * @returns {Promise} Antwort mit Erfolgs- oder Fehlerstatus
   */
  async changePassword(passwordData) {
    return await api.post('/users/change-password', passwordData);
  },

  async updatePaymentSettings(paymentData) {
    const response = await api.put('/RestaurantSettings/payment', paymentData);
    return response.data;
  }
} 